import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import { calculateBmi } from 'helper/bmi';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { actionCreators, getTempHealthGoal } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { allergyList, nutritionPhilosophyList } from '../../../../defs/dietaryHabits';
import i18n from '../../../../helper/i18n';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => {
	const parentProps = mapParentStateToProps(state, props);
	const bmiValue = calculateBmi(
		parentProps.weight === null ? undefined : parentProps.weight,
		parentProps.size === null ? undefined : parentProps.size,
		true,
		true
	);
	return {
		...parentProps,
		bmiValue,
		nutritionPhilosophyList,
		allergyList,
		tempHealthGoal: getTempHealthGoal(state),
		currentStep: ANAMNESIS_VIEWS.SELECT_DIETARY_HABITS,
		nutritionPhilosophyListTitle: i18n(
			'react.impulsCoach.components.anamnesis.selectDietaryHabits.nutritionPhilosophyListTitle'
		),
		allergiesTitle: i18n('react.impulsCoach.components.anamnesis.selectDietaryHabits.allergiesTitle'),
		introTitle: i18n('react.impulsCoach.components.anamnesis.selectDietaryHabits.introTitle'),
		introText: i18n('react.impulsCoach.components.anamnesis.selectDietaryHabits.introText'),
		// because https://inside.namics.com/display/TAFrontend/questions/520323125/answers/520716431
		title: undefined,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type SelectDietaryHabitContainerProps = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
